<template>
  <div>
    <div v-if="isShowRobot" class="robot_box">
      <div
        :style="{
          marginRight: `${isShowChat ? 60 : 150}px`,
        }"
        class="robot"
      ></div>

      <div @click="handleClose" class="close">
        <i class="el-icon-close"></i>
      </div>

      <div
        v-show="!isLoading && !isError"
        :style="{
          left: `${isShowChat ? 124 : 2}px`,
          borderRadius: `${
            isShowChat ? '117.6px 0' : '0 117.6px'
          } 117.6px 117.6px`,
        }"
        @click="isShowChat = !isShowChat"
        class="hide"
      >
        <i v-if="isShowChat" class="el-icon-arrow-left"></i>
        <i v-else class="el-icon-arrow-right"></i>
      </div>

      <div class="chat" v-if="isShowChat">
        <div v-show="askText" class="ask">{{ askText }}</div>

        <div v-show="literalAnswerText" ref="answerRef" class="answer">
          {{ literalAnswerText }}
        </div>
      </div>

      <div v-show="!isError" class="input">
        <svg width="306" height="50" viewBox="0 0 306 50">
          <defs>
            <!-- 定义用于边框的线性渐变 -->
            <linearGradient id="borderGradient" x1="1" y1="0" x2="0" y2="0">
              <stop offset="0%" style="stop-color: rgba(189, 230, 255, 0.24)" />
              <stop offset="100%" style="stop-color: rgba(255, 255, 255, 1)" />
            </linearGradient>
            <!-- 定义用于内容的线性渐变 -->
            <linearGradient id="contentGradient" x1="1" y1="0" x2="0" y2="0">
              <stop offset="0%" style="stop-color: rgba(255, 255, 255, 0.44)" />
              <stop
                offset="100%"
                style="stop-color: rgba(232, 255, 241, 0.5)"
              />
            </linearGradient>
          </defs>
          <!-- 边框 -->
          <rect
            x="0.5"
            y="0.5"
            width="305"
            height="49"
            rx="25"
            ry="25"
            fill="none"
            stroke="url(#borderGradient)"
            stroke-width="1"
          />
          <!-- 内容区域 -->
          <rect
            x="1"
            y="1"
            width="304"
            height="48"
            rx="25"
            ry="25"
            fill="url(#contentGradient)"
          />
        </svg>
        <img
          v-if="isShowVoice"
          @click="isShowVoice = false"
          src="../assets/img/robot/keyboard.png"
          alt=""
        />
        <img
          v-else
          @click="isShowVoice = true"
          src="../assets/img/robot/voice.png"
          alt=""
        />
        <div class="divider" />
        <el-input
          v-if="!isShowVoice"
          v-model.trim="value"
          @keyup.native.enter="handleSend"
          placeholder="请输入问题"
        />
        <img
          v-if="!isShowVoice"
          @click="handleSend"
          src="../assets/img/robot/send.png"
          alt=""
        />
        <div
          v-else
          class="voice"
          @mousedown="handleSpeak"
          @mouseup="handleStop"
        >
          <div v-if="isSpeaking" class="audio">
            <div
              v-for="num in 11"
              :key="num"
              :style="{
                animationDuration: getRandom(0.5, 1.2, num),
                animationDelay: getRandom(0, 0.8, num),
              }"
            />
          </div>
          <div v-else>按住说话</div>
        </div>
      </div>

      <!-- 加载动效 -->
      <div v-if="isLoading" class="mask">
        <img src="../assets/img/robot/loading.gif" alt="" />
      </div>

      <!-- 出错时占位图 -->
      <img
        v-if="isError"
        src="../assets/img/robot/error.png"
        alt=""
        class="error"
      />
    </div>

    <div v-else @click="handleOpen" class="entrance">
      <img src="../assets/img/robot/entrance.png" alt="" />
    </div>
  </div>
</template>

<script>
import { AuthToken, sendText } from "../api/robot";

export default {
  name: "robotBox",
  data() {
    return {
      isShowRobot: false,
      isLoading: false,
      isShowChat: true,
      isShowVoice: false,
      isSpeaking: false,
      isAnswering: false,
      isError: false,
      whileFlag: true,
      Client: null,
      answerTimer: null,
      mediaRecorder: null,
      conversationId: "",
      value: "",
      askText: "",
      answerText: "",
      literalAnswerText: "",
    };
  },
  computed: {},
  created() {
    document.querySelector("body").addEventListener("mouseup", this.handleStop);
  },
  methods: {
    handleOpen() {
      this.isShowRobot = true;
      this.handleInit();
    },
    handleClose() {
      this.isShowRobot = false;
      this.isError = false;
      this.askText = "";
      this.Client?.destroy();
    },
    handleInit() {
      this.isLoading = true;
      AuthToken()
        .then((res) => {
          this.Client = new window.RTCInteraction({
            mountClass: "robot",
            signature: res.data.data, // 先通过获取签名信息
            projectId: "5b9d6c1c-86e9-11ef-8b59-238f9a41efc7", // 项目ID
            bitrateEnum: "R_1080P",
            timeout: 43200000,
            onError: (err) => {
              if (err.code === 652) {
                this.askText =
                  "当前访问用户较多，请您稍作等待。如需更快响应，请稍后重试。";
                this.isLoading = false;
                this.isError = true;
                setTimeout(this.handleClose, 10000);
              }
            },
            // 初始化完成，拉流之前
            onInited: () => {
              this.Client.startRTC(); // 开启开 RTC拉流
            },
            // 对话开始前，拉流成功后\断流后重连播放
            onPlayStream: () => {
              this.isLoading = false;
            },
            // 流断开之后，重连播放
            onStopStream: () => {},
            // 开始说话之前
            onTalkStart: () => {},
            // 说话完之后
            onTalkEnd: () => {},
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async handleSend() {
      if (!this.value) return;
      this.askText = this.value;
      this.value = "";
      this.answerText = "";
      this.literalAnswerText = "";
      this.isAnswering = true;

      const response = await sendText(this.askText);
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";
      this.handleLiteralAnswer();

      while (this.whileFlag) {
        const { done, value } = await reader.read();
        if (done) {
          this.isAnswering = false;
          break;
        }

        // 将数据解码为字符串
        buffer += decoder.decode(value, { stream: true });

        // 按行分割数据，处理完整的事件行
        let lines = buffer.split("\n");
        buffer = lines.pop(); // 剩下的保留在 buffer 里，等待下次接收数据

        for (let line of lines) {
          line = line.trim();

          if (line.startsWith("data:")) {
            const data = JSON.parse(line.replace(/^data:\s*/, ""));

            if (data.answer) {
              this.Client.talk(
                data.answer,
                this.conversationId === data.conversation_id
              );
              this.conversationId = data.conversation_id;
              this.answerText += data.answer;
            }
          }
        }
      }
    },
    // 获取麦克风权限并初始化录音
    async handleSpeak() {
      try {
        let audioChunks = [];
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });

        this.mediaRecorder = new MediaRecorder(stream);

        // 监听音频数据
        this.mediaRecorder.ondataavailable = (event) => {
          audioChunks.push(event.data);
        };

        // 录制开始事件
        this.mediaRecorder.onstart = async () => {
          this.isSpeaking = true;
        };

        // 监听录制结束事件
        this.mediaRecorder.onstop = async () => {
          const audioBlob = new Blob(audioChunks, { type: "audio/mp3" });
          const arrayBuffer = await this.blobToArrayBuffer(audioBlob);
          this.handleAudioWs(arrayBuffer);
        };

        this.mediaRecorder.start();
      } catch (error) {
        console.error("无法访问麦克风:", error);
      }
    },
    /**
     * blob 转换为 ArrayBuffer
     */
    blobToArrayBuffer(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result); // 返回 ArrayBuffer
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(blob); // 读取 Blob
      });
    },
    handleAudioWs(sampleBuf) {
      const ws = new WebSocket("ws://internal.uhan.net.cn:10095");
      ws.onopen = () => {
        // 发送json
        const chunk_size = new Array(5, 10, 5);
        const request = {
          chunk_size: chunk_size,
          wav_name: "h5",
          is_speaking: true,
          chunk_interval: 10,
          itn: false,
          mode: "offline",
          wav_format: "mp3",
        };

        ws.send(JSON.stringify(request));

        ws.send(sampleBuf);

        const end = {
          chunk_size: chunk_size,
          wav_name: "h5",
          is_speaking: false,
          chunk_interval: 10,
          mode: "offline",
        };
        ws.send(JSON.stringify(end));
        console.log("连接成功");
      };

      ws.onmessage = (e) => {
        if (e.data) {
          const data = JSON.parse(e.data);
          if (data.text) {
            this.value = data.text;
            this.handleSend();
          }
        }
        ws.close();
      };

      ws.onclose = () => {
        console.log("连接断开");
      };
    },
    handleStop() {
      if (this.isSpeaking) {
        this.isSpeaking = false;
        if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
          this.mediaRecorder.stop();
        }
      }
    },
    /**
     * 回答滚动到底部
     */
    async handleAnswerScroll() {
      if (this.$refs.answerRef) {
        await this.$nextTick();
        this.$refs.answerRef.scrollTop = this.$refs.answerRef.scrollHeight;
      }
    },
    /**
     * 逐字展示
     */
    handleLiteralAnswer() {
      clearInterval(this.answerTimer);
      this.answerTimer = setInterval(() => {
        this.literalAnswerText +=
          this.answerText[this.literalAnswerText.length] || "";
        this.handleAnswerScroll();
        if (
          !this.isAnswering &&
          this.literalAnswerText.length >= this.answerText.length
        ) {
          clearInterval(this.answerTimer);
        }
      }, 100);
    },
    /**
     * 获取音柱起伏随机参数
     */
    getRandom(min, max, num) {
      return Math.random() * (max - min) + min + 0.00001 * num + "s";
    },
  },
  beforeDestroy() {
    document
      .querySelector("body")
      .removeEventListener("mouseup", this.handleStop);
  },
};
</script>

<style lang="scss" scoped>
.robot_box,
.entrance {
  position: fixed;
  z-index: 999999;
}

.robot_box {
  position: fixed;
  bottom: 150px;
  right: -174px;
  display: flex;

  .close {
    position: absolute;
    z-index: 1;
    top: 22px;
    right: 174px;
    width: 41px;
    height: 41px;
    border-radius: 117.6px 0 0 117.6px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.14);
    cursor: pointer;

    .el-icon-close {
      font-size: 20px;
      color: #fff;
    }
  }

  .hide {
    position: absolute;
    z-index: 4;
    top: 334px;
    width: 41px;
    height: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
    transition: all 0.7s;
    cursor: pointer;

    .el-icon-arrow-left,
    .el-icon-arrow-right {
      font-size: 20px;
      color: #fff;
    }
  }

  .chat {
    position: absolute;
    top: 257px;
    left: -96px;
    width: 200px;
    height: 320px;
    word-wrap: break-word;
    font-size: 15px;

    .ask {
      box-sizing: border-box;
      float: right;
      margin-bottom: 24px;
      width: 190px;
      min-height: 45px;
      border: 2px solid transparent;
      border-radius: 18px 2.7px 18px 18px;
      padding: 10px 19px 7px 17px;
      line-height: 24px;
      background: linear-gradient(
            90deg,
            rgba(60, 141, 255, 1),
            rgba(5, 252, 199, 1)
          )
          padding-box,
        linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))
          border-box;
      color: #fff;
    }

    .answer {
      box-sizing: border-box;
      float: left;
      width: 202px;
      min-height: 45px;
      max-height: 320px;
      border: 2px solid #fff;
      border-radius: 2.7px 18px 18px 18px;
      padding: 17px 14px 10px 18px;
      overflow: auto;
      line-height: 24px;
      background: rgba(255, 255, 255, 0.8);
      color: rgba(31, 31, 31, 1);

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }
  }

  .robot {
    width: 410px;
    height: 700px;
    transition: all 0.7s;
  }

  .input {
    position: fixed;
    bottom: 97px;
    right: 38px;
    width: 306px;
    height: 50px;
    box-shadow: 0px 30px 40px rgba(87, 130, 129, 0.2);
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #fff;

    svg {
      position: absolute;
      z-index: -1;
      top: 0;
      bottom: 0;
    }

    img {
      margin-left: 16px;
      width: 22px;
      height: 22px;
      cursor: pointer;

      &:last-child {
        margin: 0 13px 0 6px;
        width: 32px;
        height: 32px;
      }
    }

    .divider {
      margin: 0 6px 0 14px;
      width: 2px;
      height: 40px;
      background: linear-gradient(
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 63.55%,
        rgba(255, 255, 255, 0) 100%
      );
    }

    ::v-deep .el-input {
      flex: 1;
      .el-input__inner {
        border: unset;
        padding: unset;
        font-size: 16px;
        background: unset;
        color: #fff;
        cursor: pointer;

        .el-input__inner::placeholder {
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }

    .voice {
      margin-right: 74px;
      height: 100%;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;

      .audio {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: end;
        align-items: center;

        & > div {
          margin: 0 4px;
          border-radius: 8px;
          width: 5px;
          height: 14px;
          background: #fff;
          animation: audio-wave 2s linear infinite;
        }
      }

      @keyframes audio-wave {
        0% {
          height: 10px;
        }
        50% {
          height: 25px;
        }
        100% {
          height: 10px;
        }
      }
    }
  }

  .mask {
    position: absolute;
    top: 20px;
    left: -96px;
    width: 392px;
    height: 735px;
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 200px;
      height: auto;
    }
  }

  .error {
    position: absolute;
    z-index: -1;
    top: 90px;
    left: 62px;
    width: 191px;
  }
}

.entrance {
  bottom: 5px;
  right: -45px;
  cursor: pointer;
}
</style>
